import { combineReducers } from '@reduxjs/toolkit';
import authReducer from "../hire-talent/reducers/authReducer"
import projectReducer from "../hire-talent/reducers/projectReducer"
const hireTalentReducer = combineReducers({
  auth: authReducer,
  project: projectReducer,
});

export default hireTalentReducer;

